// Runtime configuration. Intervals are deliberately conservative so a large
// fleet doesn't hammer the backend; native shells can tune these.

export const config = {
  apiBaseUrl: import.meta.env.VITE_DEVICE_API_URL ?? "/device",
  useMock: (import.meta.env.VITE_USE_MOCK ?? "true") === "true",
  appVersion: import.meta.env.VITE_APP_VERSION ?? "0.0.0-dev",

  pairingPollIntervalMs: 3_000,
  syncIntervalMs: 30_000,
  heartbeatIntervalMs: 60_000,
  popFlushIntervalMs: 60_000,

  // A refresh that fails in transit is retried quickly: the server still accepts a
  // just-rotated refresh token for DEVICE_REFRESH_GRACE_SECONDS (60s), so a lost
  // response must be retried well inside that window — not at the next 30–60s tick.
  refreshRetryDelaysMs: [2_000, 5_000, 15_000],
  // Per attempt: a silently dropped connection must fail fast enough that the
  // retries still land inside the grace window.
  refreshTimeoutMs: 8_000,
  // Back-off while the backend refuses to register this device (it still has the
  // device as paired, or is unreachable). The last delay repeats.
  registerRetryDelaysMs: [30_000, 60_000, 120_000, 300_000],

  // Clock-driven playback tick. Playback position is derived from the
  // (server-adjusted) wall clock every tick, so playback is crash-resilient
  // and all screens stay in lockstep.
  playbackTickMs: 250,

  // A clock-offset jump beyond this is logged loudly: it means the local clock
  // drifted (VM suspend, sleep) and every proof-of-play stamped meanwhile may
  // sit outside the backend's ±120s trust-gate slack. Matches that slack.
  clockJumpWarnMs: 120_000,
} as const;

export type Config = typeof config;
